import React, { useState } from 'react';
import { connect } from 'react-redux';
import { SearchOutlined } from '@ant-design/icons';
import ModalSearch from './SearchModal';
import Hotkeys from "react-hot-keys";
import { css } from 'styled-components';
import { getKeysString, hotkeyAction, hotkeyToAction } from './helper.hotkeys';

export const KeyboardButtonStyled = css`

    /* adapted from https://www.npmjs.com/package/keyboard-css */
    .kbd-btn {
        display: inline-block;
        padding: 0.1rem 0.4rem;
        margin: 0.25rem 0.25rem 0.4375rem;
        font-family: SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
        font-size: inherit;
        font-weight: 400;
        line-height: inherit;
        color: #343a40;
        text-align: left;
        background-color: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 0.25rem;
        box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 
        0 3px #d9d9d9, 0 4px #d9d9d9, 0 5px #d9d9d9, 2px 2.5px 4px #adb5bd, 0 -1px 2.5px #adb5bd;
        transition: all .25s cubic-bezier(.2,1,.2,1);
        transform: translateZ(5px);

        /* -webkit-backface-visibility: hidden; */
        backface-visibility: hidden;
        transform-style: preserve-3d;

        &.kbd-btn-xs {
            padding: 0.175rem 0.5rem;
            margin: 0.3125rem 0.3125rem 0.4375rem;
            font-size: .675rem;
            line-height: 1.5;
            border-color: #e6e6e6;
            box-shadow: 0 0 #d9d9d9, 0 0 #d9d9d9, 0 1px #d9d9d9, 0 2px #d9d9d9, 
            2px 1px 4px #adb5bd, 0 -1px 1px #adb5bd;
        }

        &.space {
            padding-right: 20px;
            padding-left: 20px;
        }

        &.clickable {
            cursor: pointer;
            user-select: none;

            &:hover {
                border-color: #c6c6c6;
                transform: translateZ(2px);
            }

            &:active {
                border-color: #c6c6c6;
                transform: translateZ(6px);
            }

            &:focus {
                outline: none;
                outline: 4px solid #91caff;
                outline-offset: 1px;
                transition: outline-offset 0s,outline 0s;
            }
        }
    }

    .kbd-arrow-button-group {
        .kbd-btn {
            padding: 0.15rem 0.5rem;
            margin: 0.1rem;
            font-size: 0.875rem;
        }
    }
`;

export function GlobalSearch() {
    const [isModalVisible, setModalVisible] = useState(false);

    // keyboard shortcut to open/close search modal
    const onKeyDown = (keyName, e) => {
        // console.log('aaa onKeyDown', {keyName, e});

        const target = document.activeElement;
        const { tagName, classList } = target;

        switch (hotkeyToAction[keyName]) {
            case hotkeyAction.TOGGLE_GLOBAL_SEARCH_SLASH:
                // only open search when not focusing on other inputs/select/textarea
                // and are not in modal/drawer
                // https://github.com/jaywcjlove/hotkeys#filter

                // console.log('aaa target TOGGLE_GLOBAL_SEARCH_SLASH', {tagName, classList});
                // // if (!document.activeElement || document.activeElement.tagName === 'BODY')
                if (!(target.isContentEditable ||
                    tagName === 'INPUT' || tagName === 'SELECT' ||
                    tagName === 'TEXTAREA' || tagName === 'BUTTON' ||
                    classList.contains('ant-drawer') || classList.contains('ant-modal-wrap')
                )) {
                    // Prevent / (forward slash) key from triggering search in firefox
                    // So that GlobalSearch can use it
                    e.preventDefault();
                    setModalVisible(true);
                }
                break;
            default:
                break;
        }
    };

    const onSearchIconClick = () => {
        setModalVisible(true);
    };

    return (
        <div style={{ alignContent: 'center', justifyContent: 'center', display: 'flex' }}>
            <Hotkeys
                keyName={getKeysString([hotkeyAction.TOGGLE_GLOBAL_SEARCH_SLASH])}
                // onKeyUp={onKeyUp}
                onKeyDown={onKeyDown}
            // onKeyDown={onKeyUp} // prevent browser default action of keydown
            // className={className}
            >
                <ModalSearch
                    visible={isModalVisible}
                    handleCancel={() => {
                        setModalVisible(false);
                    }}
                />
                <SearchOutlined
                    onClick={onSearchIconClick}
                    id="global-search-icon"
                />
            </Hotkeys>
        </div>
    );
}

export default connect(() => ({}), {})(GlobalSearch);
